import * as React from 'react';
import { useIntl } from 'react-intl';
import { message } from 'antd';
import appStore from '@/stores';

function useExportAnimation() {
  const intl = useIntl();
  const runAnimation = React.useCallback((e?: React.MouseEvent) => {
    void e;
    message.info(intl.formatMessage({
      defaultMessage: `正在导出中, 稍后可在 “<url>导出中心</url>” 查看`}, {
      url: (chunks: React.ReactNode[]) => <a target="_blank" href={`${appStore.config.edsUrl}/ExportCenter/index?version=${new Date().getTime()}`} rel="noreferrer">{chunks}</a>,
    }));

    // const cart = window.microAppConfig?.ufileCartDom;
    // if (!cart) return;

    // const flyEl = document.createElement('div');
    // flyEl.style.position = 'fixed';
    // flyEl.style.zIndex = '10';
    // flyEl.style.top = `${e.clientY}px`;
    // flyEl.style.left = `${e.clientX}px`;
    // flyEl.style.background = '#40a9ff';
    // flyEl.style.width = '12px';
    // flyEl.style.height = '12px';
    // flyEl.style.borderRadius = '50%';
    // flyEl.style.willChange = 'top, left';
    // flyEl.style.transition = `top ${speed /
    //   1000}s ease-in-out, left ${speed /
    //   1000}s ease-in-out`;
    // document.body.appendChild(flyEl);

    // const rect = cart.getBoundingClientRect();
    // flyEl.style.top = `${rect.top + (rect.height / 2)}px`;
    // flyEl.style.left = `${rect.left + (rect.width / 2)}px`;

    // setTimeout(() => {
    //   // cart.querySelector('.waiting').classList.add('red');
    //   flyEl.remove();
    // }, speed * 1.1);

  }, []);

  return runAnimation;
}

export default useExportAnimation;
